import { FileProvider } from "./FileContext";
import { PreProcessingColProvider } from "./PreProcessingColContext";
import { ResultProvider } from "./ResultsContext";
import { SessionExportProvider } from "./SessionExportContext";
import { ThemeModeProvider } from "./ThemeModeContext";

export const AppContexts = ({ children }) => {
  return (
    <FileProvider>
      <ResultProvider>
        <PreProcessingColProvider>
          <SessionExportProvider>
            <ThemeModeProvider>{children}</ThemeModeProvider>
          </SessionExportProvider>
        </PreProcessingColProvider>
      </ResultProvider>
    </FileProvider>
  );
};

export { useFile } from "./FileContext";
export { usePreProcessing } from "./PreProcessingColContext";
export { useResult } from "./ResultsContext";
export {
  useSessionExport,
  useRegisterSessionExport,
  useRegisterGeoJsonExport,
  useRegisterPdfExport,
} from "./SessionExportContext";
export { useThemeMode } from "./ThemeModeContext";
